<div  class="row   bg-white border-bottom box-shadow mb-3" style="box-shadow: 0 0.25rem 0.75rem #002244 !important ">
  <div class="col-4">
    <h3 class="my-auto" *ngIf="canViewExcel== null || canViewExcel=='' || canViewExcel=='N'"
      style="margin-left:2rem"><a class="navbar-brand" href="#"><img alt="Department of Aging"
          src="assets/images/ODA_Logo_340x88_Transparent.png" /></a></h3>
    <h3 class="my-auto" *ngIf="canViewExcel=='Y'" style="margin-left:2rem"><a class="navbar-brand" href="#"><img
          width="350" height="100" alt="Department of Aging" src="assets/images/ODA_EXCEL_HORI.png" /></a></h3>
  </div>
  <div class="col-4">
    <h4 style="text-align: center; color: #002244 !important ;vertical-align: middle;
line-height: 90px;" class="title">Care Center</h4>
  </div>
  <div class="col-4">
   <div style="float: right;">
    <div *ngIf="contextFacility && !isAdmin" style="margin-top: 10px; margin-right: 5px;">
      <div style="font-weight: bold;font-size: 15px;color: #670808;">{{ contextFacility?.name }} - {{
        contextFacility?.stateId}} </div>
      <div style=" font-size: 13px;color: #4a4a4a; ">
        <div>{{ contextFacility?.address1 }} </div>
        <div>{{ contextFacility?.city }}, {{ contextFacility?.state }} {{ contextFacility?.zip }}</div>
      </div>
  </div>
  <div *ngIf="contextPharmacy  && !isAdmin">
    <div style="    font-weight: bold;font-size: 15px;color: #670808;">{{ contextPharmacy?.name }} </div>
    <div style=" font-size: 13px;color: #4a4a4a; ">
      <div>{{ contextPharmacy?.address }} </div>
      <div>{{ contextPharmacy?.city }}, {{ contextPharmacy?.state }} {{ contextPharmacy?.zip }}</div>
    </div>
  </div>
   </div> <br>

</div>
</div>